import React, { useState } from "react";
import CustomSelect from "../../../../common/CustomSelect/index";

import {
  IconColumn,
  IconFilter,
  IconPen,
  IconPlus,
  IconTrash,
} from "../../../../common/icons/index";

const tableHeaderData = [
  "Trailer #",
  "License plate #",
  "VIN",
  "Address",
  "AID",
  "ITD",
  "Registration",
  "Inspection",
  "HUT",
];
const tableData = [];
for (let i = 0; i < 20; i++) {
  tableData.push({
    id: i,
    trailer: `POP2_M10052` + i,
    lisence: "4cF82821",
    lisenceState: "Florida",
    vin: "4cF82821",
    address: "3891 Ranchview Dr. Richardson, California 62639",
    aid: "06/11",
    itd: "06/11",
    registration: "06/11/21",
    inspectionDate: "06/11",
    hut: "06/11/21",
  });
}

const StaticTableContent = () => {
  const [isPopDrop, setIsPopDrop] = useState(false);

  const handlePopDrop = (event) => {
    setIsPopDrop(!isPopDrop);
  };
  return (
    <React.Fragment>
      {/* Filter Row */}
      <div className="filter-row d-flex align-items-center">
        <div className="app-search header-search">
          <span className="search-icon"> </span>
          <div className="position-relative">
            <input
              type="search"
              className="form-control input-search-left"
              placeholder="Search..."
              value=""
            />
          </div>
        </div>
        <div className="d-flex">
          <div className="form-check form-check--gray pr-30">
            <input
              className="form-check-input"
              type="checkbox"
              id="Available"
            />
            <label className="form-check-label" for="Available">
              Enabled
              <span className="badge badge-gray-100 font-12 ml-2 badge-pill">
                47
              </span>
            </label>
          </div>
          <div className="form-check form-check--gray pr-30">
            <input className="form-check-input" type="checkbox" id="Pending" />
            <label className="form-check-label" for="Pending">
              Disabled
              <span className="badge badge-gray-100 font-12 ml-2 badge-pill">
                6
              </span>
            </label>
          </div>
        </div>
        <div className="ml-auto d-flex">
          <button className="btn btn-outline-light mr-2">
            <IconFilter className="mr-2" />
            Filter
          </button>
          <div className="position-relative">
            <button className="btn btn-outline-light position-relative">
              <IconColumn />
            </button>
          </div>
        </div>
      </div>
      {/* Table */}
      <div
        className="table-responsive"
        style={{ height: "calc(100vh - 325px)" }}
      >
        <table className="table table-card table-card--ls">
          <thead>
            <tr>
              <th>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="sr_no"
                />
              </th>
              {tableHeaderData.map((headetItem) => {
                return (
                  <th scope="col" key={headetItem}>
                    {headetItem}
                  </th>
                );
              })}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((tdata) => {
              return (
                <tr key={tdata.id}>
                  <td>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="sr_no"
                    />
                  </td>
                  <td>
                    <a href="#" className="text-primary">
                      {tdata.trailer}
                    </a>
                  </td>
                  <td>
                    <div>{tdata.lisence}</div>
                    <div className="text-muted">{tdata.lisenceState}</div>
                  </td>
                  <td>{tdata.vin}</td>
                  <td>{tdata.address}</td>
                  <td>{tdata.aid}</td>
                  <td>{tdata.itd}</td>
                  <td className="py-0">
                    <div className="bg-warning-50 h-100 d-flex align-items-center justify-content-center px-1">
                      {tdata.registration}
                    </div>
                  </td> 
                  <td>{tdata.inspectionDate}</td>
                  <td className="py-0">
                    <div className="bg-warning-200 h-100 d-flex align-items-center justify-content-center px-1">
                      {tdata.hut}
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      <button className="btn btn-link text-primary">
                        <IconPen />
                      </button>
                      <button className="btn btn-link">
                        <IconTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </React.Fragment>
  );
};
export default StaticTableContent;
